<template>
  <div class="flex-center">
    <div style="width:564px">
    <div class="text-center">
      <div class="h6 main">플랜변경이 완료되었습니다.</div>
      <div class="body2 sub3" style="margin-top:12px">플랜 변경이 완료되었습니다. 변경된  서비스 결제 정보와 이용 정보를 확인하세요. </div>
    </div>
    <div class="main" style="margin-top:32px;">
      <div class="h8">변경 플랜</div>
      <div class="lp-divider-main" style="margin-top:16px;margin-bottom:16px"></div>

      <div class="flex-between">
        <div>
          <div>
            <span class="body4">{{ memberShip.name }}</span>
            <span class="body4" style="margin-left:4px">
               <template v-if="service && service.service_order.trial">
                ({{ dateUnitText }}{{ trial_product.month_free?'+1개월':'' }})
              </template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
          <div>
            <span class="body4 sub3">결제일/서비스 이용 시작일</span>
            <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
          </div>
        </div>
        <div class="flex-align" v-if="memberShip">
          <div>
            <span class="body2-bold main">{{ memberShipPrice | currencyNum }}</span>
            <span class="body4 sub">원</span>
            <span class="size-14 sub4">/<template v-if="service && service.service_order.trial">{{ trial_product.month_free?`(${order_product.date_unit}+1)개월`:`${dateUnitText}` }}</template>
              <template v-else>{{ dateUnitText }}</template></span>
          </div>
        </div>
      </div>
      <div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
      <div class="flex-between">
        <div>
          <div>
            <span>BASIC 호스팅</span>
            <span class="body4" style="margin-left:4px"><template v-if="service && service.service_order.trial">
                ({{ dateUnitText }}{{ trial_product.month_free?'+1개월':'' }})
              </template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
          <div>
            <span class="body4 sub3">결제일/서비스 이용 시작일</span>
            <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
          </div>
        </div>
        <div class="flex-align">
          <div>
            <span class="body2-bold main">{{ hostingPrice | currencyNum }}</span>
            <span class="body4 sub">원</span>
            <span class="size-14 sub4">/<template v-if="service && service.service_order.trial">{{ trial_product.month_free?`(${order_product.date_unit}+1)개월`:`${dateUnitText}` }}</template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
        </div>
      </div>
      <template v-if="service && service.service_order.trial">
        <div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
        <div class="flex-between">
          <div>
            <div>
              <span class="body4">추가 팩/플러그인</span>
            </div>
            <div>
              <span class="body4 sub3">결제일/서비스 이용 시작일</span>
              <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
            </div>
          </div>
          <div class="flex-align">
            <div>
              <span class="body2-bold main">{{ packPluginPrice | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </div>
      </template>
      <!-- 앱포팅 건결제 -->
      <template v-if="trial_product.app_porting">
        <div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
        <div class="flex-between">
          <div>
            <div>
              <span>앱포팅 등록 및 대행 할인</span>

            </div>
            <div>
              <span class="body4 sub3">결제일</span>
              <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
            </div>
          </div>
          <div class="flex-align">
            <div>
              <span class="body2-bold main">{{ trialPrice | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </div>
      </template>

      <!-- 무료 1개월 -->
      <!--<template v-if="trial_product.month_free">
        <div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
        <div class="flex-between">
          <div>
            <div>
              <span>무료 1개월 이용권 추가</span>

            </div>
            <div>
              <span class="body4 sub3">결제일</span>
              <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
            </div>
          </div>
          <div class="flex-align">
            <div>
              <span class="body2-bold main">{{ 0 | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </div>
      </template>-->
      <!--<div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
      <div class="flex-between">
        <div>
          <div>앱포팅</div>
          <div>
            <span class="body4 sub3">결제일/서비스 이용 시작일</span>
            <span class="body4 sub2" style="margin-left:4px">{{ payday }}</span>
          </div>
        </div>
        <div class="flex-align">
          <div></div>
          <div style="margin-left:190px"></div>
        </div>
      </div>-->
      <div class="lp-divider-gray1" style="margin-top:16px;margin-bottom:16px"></div>
      <div class="flex-center">
        <div class="body5 sub3">*모든 가격은 부가가치세를 제외한 것입니다.</div>
      </div>
      <div class="flex-center">
        <div class="body5 sub3">*변경된 플랜으로, 서비스 재배포되었습니다. 약 5분 뒤에 서비스에 변경된 플랜으로 적용됩니다.</div>
      </div>
      <div class="flex-center">
        <div class="body5 sub3" v-if="trial_product.app_porting">*앱포팅 작업과 관련해서는 별도 안내가 진행될 예정입니다.</div>
      </div>

      <div class="flex-center" style="margin-top:32px;">
        <!--<button class="button is-primary body2-medium" style="width:200px;height:48px !important;">서비스 결제 정보</button>-->
        <button class="button body2-medium" style="margin-left:16px;width:200px;height:48px !important;" @click="$emit('close')">닫기</button>
      </div>
    </div>

  </div>
  </div>
</template>
<script>
  export default {
    name: "PlanChangeStep3",
    props: {
      service: {
        type: Object
      },
      hosting: {
        type: Object
      },
      order_product: {
        type: Object
      },
      selectorStocks: {
        type: Array
      },
      trial_product: {
        type: Object
      }
    },
    created() {
      this.getPlanChangePayDay();
    },
    data() {
      return {
        payday: ''
      }
    },
    computed: {
      packPluginPrice() {
        let price = 0;
        if(this.service && this.service.service_app_order.length>0) {
          let order = this.service.service_app_order
          order.forEach(item=>{
            price += item.subscribe_price * 10 / 11
          })
        }
        return price
      },
      dateUnitText() {
        return this.order_product.date_unit + '개월'
      },
      totalPrice() {
        return this.memberShipPrice + this.hostingPrice + this.trialPrice;;
      },
      memberShipPrice() {
        let price = 0;
        let option_id = this.order_product.order_product_option[0].option_id;
        let stock = find(this.selectorStocks, 'id', option_id);
        let option = find(this.order_product.product.selectors[0].options, 'id', stock.options[0]);
        if(this.order_product.date_unit===1) {
          price = option.price * this.order_product.date_unit;
        } else {
          let subs = find(option.subscriptions, 'date_unit', this.order_product.date_unit);
          price = subs.price * this.order_product.date_unit;
        }
        return price;
      },
      hostingPrice() {
        let price = 0;
        if(this.hosting) price = this.hosting.price * this.order_product.date_unit;
        return price;
      },
      memberShip() {
        let option_id = this.order_product.order_product_option[0].option_id;
        return find(this.selectorStocks, 'id', option_id);
      },
      trialPrice() {
        let price = 0;
        if(this.trial_product.app_porting) price = 780000
        return price;
      }
    },
    methods: {
      getPlanChangePayDay() {
        if (this.service.service_order.trial) this.payday = this.moment().format('YYYY-MM-DD')
        else if (this.service.status === 10) this.payday = this.moment().format('YYYY-MM-DD')
        else {
          let url = this.masterBackendUrl + 'public/launchpack/plan_change/pay_day'
          // let url = 'http://localhost:8001' + '/public/launchpack/plan_change/pay_day'
          let params = {
            order_id: this.service.service_order.id,
            update_date_unit: this.order_product.date_unit,
            option_id: this.order_product.order_product_option[0].option_id
          }
          this.$axios.post(url, params).then(res => {
            this.payday = res.data;
          })
        }
      }
    },
  }
</script>
<style lang="stylus" scoped>
</style>
